<template>
  <div class="card widget-flat">
    <div class="card-body">
      <div class="float-end">
        <i :class="`mdi ${icon} widget-icon`"></i>
      </div>
      <h5 class="text-muted fw-normal mt-0" :title="title">{{ title }}</h5>
      <h3 class="mt-3 mb-3">{{ number }}</h3>
      <p class="mb-0 text-muted">
        <span class="me-2" :class="`text-${color}`">
          <i
            :class="{
              'mdi mdi-arrow-down-bold': color === 'danger',
              'mdi mdi-arrow-up-bold': color === 'success',
            }"
          ></i>
          {{ subtext }}
        </span>
        <span class="text-nowrap">Since last period</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * A simple widget component with an icon and statistical data.
 * Props:
 * 1. `icon` (String): Specifies the widget icon name.
 * 2. `title` (String): Represents the title of the widget (e.g., "Sales").
 * 3. `number` (String): Displays a value for the title (e.g., "1500").
 * 4. `color` (String): Defines the trend color for the widget (e.g., "success" or "danger").
 * 5. `bgColor` (String): Sets the background color of the widget.
 * 6. `subtext` (String): Shows additional trend information related to the title.
 * 7. `iconColor` (String): Sets the color of the icon.
 */

export default defineComponent({
  props: {
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    title: {
      type: String,
      default: '',
    },
    number: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'success',
    },
    bgColor: {
      type: String,
      default: 'primary',
    },
    subtext: {
      type: String,
      default: '',
    },
  },
})
</script>
